import React from 'react'
import moto from '../../assets/images/recomendacion/moto.jpg'
import '../../css/viajarConMoto.scss'
import Footer from '../Footer'

export default function ViajasConMoto() {
  return (
    <>
    <section>
        <div className='container'>
            <div className='viajar-con-moto-content'>
                <div className='viajar-con-moto'>
                    <h2>Pasajeros con motocicleta</h2>
                    <p><strong>Cinchos de seguridad:</strong> Es necesario que cada motocicleta sea asegurada adecuadamente durante el transporte.</p>
                    <p>Para ello, se requiere que los pasajeros cuenten con al menos tres cinchos de buena calidad. Estos se utilizarán para fijar la motocicleta en tres puntos diferentes, de esta manera, viajara de forma segura durante la travesía evitando cualquier movimiento que pueda dañarla o causar inconvenientes.</p>
                    <strong>* No es posible trasladar motocicletas sin conductor.</strong>   
                </div>  
                <div className='viajar-con-moto'>
                    <img src={moto} alt='moto baja ferries'/>
                </div>
                            
            </div>
        </div>

        <Footer />
    </section>
    </>
  )
}
